import styles from "./MSwitch.module.scss";

interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    size?: "small" | "medium";
}

const MSwitch = ({ checked, onChange, disabled = false, size = "medium" }: SwitchProps) => {
    const sizeClass = size === "small" ? styles.small : "";

    return (
        <label className={`${styles.switchLabel} ${disabled ? styles.disabled : ""}`} data-testid='switch-label'>
            <div
                className={`${styles.switch} ${sizeClass} ${checked ? styles.switchOn : ""} ${
                    disabled ? styles.switchDisabled : ""
                }`}
                data-testid='switch-container'
            >
                <input
                    type='checkbox'
                    checked={checked}
                    onChange={(e) => {
                        if (!disabled) {
                            onChange(e.target.checked);
                        }
                    }}
                    disabled={disabled}
                    className={styles.switchInput}
                />
                <span className={styles.switchSlider}></span>
            </div>
        </label>
    );
};

export default MSwitch;
